import { useQuery } from '@tanstack/react-query';
import { isListEnabled } from 'utils/queryHelpers';

import { QueryContextFromKeys, QueryParamModel } from 'models';
import { statisticsService } from 'services';

type ReadingFailureReasonsQueryContexts = QueryContextFromKeys<typeof readingFailureReasonsKeys>;

export const readingFailureReasonsKeys = {
  all: [{ scope: 'readingFailureReasons' }] as const,
  lists: () => [{ ...readingFailureReasonsKeys.all[0], entity: 'list' }] as const,
  list: (params?: QueryParamModel | null) =>
    [{ ...readingFailureReasonsKeys.lists()[0], params }] as const,
};

const fetchReadingFailureReasonsList = async ({
  queryKey: [{ params }],
}: ReadingFailureReasonsQueryContexts['list']) =>
  statisticsService.getReadingFailureReasonsList(params);

const exportReadingFailureReasons = async ({
  queryKey: [{ params }],
}: ReadingFailureReasonsQueryContexts['list']) =>
  statisticsService.exportReadingFailureReasons(params);

export const useReadingFailureReasonsList = (params?: QueryParamModel | null) => {
  return useQuery({
    queryKey: readingFailureReasonsKeys.list(params),
    queryFn: fetchReadingFailureReasonsList,
    enabled: isListEnabled(params),
  });
};

export const useExportReadingFailureReasons = (params?: QueryParamModel | null) => {
  return useQuery({
    queryKey: readingFailureReasonsKeys.list(params),
    queryFn: exportReadingFailureReasons,
    enabled: false,
  });
};
